import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/loginBySSO', component: () => import('@/views/loginBySSO/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph',
    children: [{
      path: 'photograph',
      name: 'photograph',
      component: () => import('@/views/photograph/index'),
      meta: {title: '撸宠模板', icon: 'order'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph-doc',
    children: [{
      path: 'photograph-doc',
      name: 'photograph-doc',
      component: () => import('@/views/photograph/doc'),
      meta: {title: '接口文档', icon: 'order'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph-preview',
    children: [{
      path: 'photograph-preview',
      name: 'photograph-preview',
      component: () => import('@/views/photograph/preview'),
      meta: {title: '预览效果', icon: 'order'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph-history',
    children: [{
      path: 'photograph-history',
      name: 'photograph-history',
      component: () => import('@/views/photograph/history'),
      meta: {title: '历史记录', icon: 'order'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph-decopyright',
    children: [{
      path: 'photograph-decopyright',
      name: 'photograph-decopyright',
      component: () => import('@/views/photograph/decopyright'),
      meta: {title: '去版权工具', icon: 'order'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph-worker',
    children: [{
      path: 'photograph-worker',
      name: 'photograph-worker',
      component: () => import('@/views/photograph/worker'),
      meta: {title: 'Worker管理', icon: 'order'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/photograph-workflow',
    children: [{
      path: 'photograph-workflow',
      name: 'photograph-workflow',
      component: () => import('@/views/photograph/workflow'),
      meta: {title: ' 算法管理', icon: 'order'}
    }]
  },
]

export const asyncRouterMap = [
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap,
})




// WEBPACK FOOTER //
// ./src/router/index.js